@if (assignCartTabOpen) {
  <div
    class="assign-cart-tab-container"
    cdkDrag
    cdkDragLockAxis="y"
    cdkDragBoundary=".assign-cart-tab"
    >
    <!-- Assign Tab Button -->
    <button
      class="assign-cart-tab-add-button"
      mat-fab aria-label="Assign Cart Button"
      (click)="openAssignSidePanel()"
      >
      <mat-icon
        [matBadge]="getCartItems(cartItems)"
        class="assign-button-icon"
      >add</mat-icon>
    </button>
    <h4 class="assign-cart-tab-add-label">
      Assign Cart
    </h4>
    <mat-icon
      class="assign-cart-tab-drag-icon"
      >drag_indicator
    </mat-icon>
  </div>
}
